import "../../../../src/pages/styles/main.css";
import CreatorToolBox from "../../../../src/pages/add-ons/creatorToolBox.md";
import DeveloperToolBox from "../../../../src/pages/add-ons/developerTool.md";
import SpaceContent from "../../../../src/pages/add-ons/spaceAbility.md";
import LearnMoreBtn from "../../../../src/pages/add-ons/learnmore.md";
import bgImg from "../../../../src/pages/images/Summary_BgImage.jpg";
import heroVideo from "../../../../src/pages/videos/R2_Add-on.mp4";
import * as React from 'react';
export default {
  CreatorToolBox,
  DeveloperToolBox,
  SpaceContent,
  LearnMoreBtn,
  bgImg,
  heroVideo,
  React
};